import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIntentProperties, setDateRangeReports, setListSegmentReport } from '../../../../actions/subscriber';
import { callTokenApi } from '../../../../apiCaller';
import { API_CLIENT_GET_LIST_SEGMENT_REPORT, API_CLIENT_REPORTING_CONVERSION_NAME, API_CLIENT_SEGMENT_REPORT, BQ_JOB_STATUS, REPORT_NAMES, REPORT_TYPE, SCOPED, SECTION_REPORT, SESSION_STORAGE_REPORT_DATE_RANGE } from '../../../../constants';
import { toastError } from '../../../../utils';
import { handleGetSortSegment } from './EventExplorer';
import { handleRemoveSegmentReportWithExternalCustomObjectReport } from '../../../../helpers/cms/subscriber';

const useFirstFetchReportData = (props) => {
     const {
          isConversionNameRate,
          isConversionName,
          isConversionAllReport,
          isSalesConversionName,
          setConversionName,
          setConversionNameMetric,
          reportName,
          setSegmentSticky,
          setSort,
          filterMetric,
          dataParamValue,
          recordProfile,
          dateRangeConfig,
          setDateRangeConfig,
          dateScopes,
          defaultDateRange,
          setListSegmentReportApply,
          setListChartSegmentApply,
          setDefaultConfig,
          reportViewParam,
          reportType,
          customObjectSF,
          SFObject,
     } = props;

     const dispatch = useDispatch();

     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const user = useSelector((state) => state.theme.user);
     const dateRangeReportNoSticky = useSelector((state) => state.subscriber.dateRangeReportNoSticky);
     const externalObjectReport = useSelector((state) => state.subscriber.externalObjectReport);
     const customExternalObjectReport = useSelector((state) => state.subscriber.customExternalObjectReport);

     const accountId = activeAccount.id;
     const userId = user.id;

     const { segmentId: paramSegmentId } = dataParamValue || {};

     // Get externalId for Custom External reports
     const externalId = reportType === REPORT_TYPE.CUSTOM_EXTERNAL
          ? customExternalObjectReport?.find(obj => obj.object === SFObject)?.externalId
          : null;

     const bodyData = {
          accountId,
          isConversionName,
          isConversionNameRate,
          isConversionAllReport,
          reportName,
          reportType,
          ...(externalId && { externalId }), // Only include if exists
     };

     const isSaveReport = reportViewParam
     const [conversionNameLoading, setConversionNameLoading] = useState(true);

     useEffect(() => {
          const fetchData = async () => {
               if (!recordProfile) {
                    await callTokenApi(
                         API_CLIENT_GET_LIST_SEGMENT_REPORT.replace(':accountId', accountId) + `?reportName=${reportName}&reportType=${reportType}&userId=${userId}${SFObject ? `&object=${SFObject}` : ``}`,
                         'GET',
                         null
                    ).then((response) => {
                         if (response?.status !== 200) {
                              toastError(response);
                              return;
                         }

                         const { segmentReport, segmentSticky, defaultConfig, segmentChart } = response.data;

                         if (Array.isArray(segmentReport)) {
                              let listSegmentReportApply = [];
                              let newListSegmentReportApply = [];

                              if (typeof paramSegmentId !== 'undefined') {
                                   const newSegmentReport = segmentReport.map((item) => ({ ...item, apply: item.id === paramSegmentId }));
                                   newListSegmentReportApply = newSegmentReport.filter((item) => item.id === paramSegmentId);
                                   listSegmentReportApply = newListSegmentReportApply.filter((item) => item.apply && item.queryStatus === BQ_JOB_STATUS.DONE);

                                   dispatch(setListSegmentReport(newSegmentReport));
                                   setListSegmentReportApply(newListSegmentReportApply);
                              } else {
                                   listSegmentReportApply = segmentReport.filter((item) => item.apply && item.queryStatus === BQ_JOB_STATUS.DONE);
                                   newListSegmentReportApply = [...listSegmentReportApply]
                                        .sort((a, b) => {
                                             if (a.isCustom !== b.isCustom) {
                                                  return a.isCustom ? 1 : -1;
                                             }
                                             return new Date(a.orderBy) - new Date(b.orderBy)
                                        });

                                   dispatch(setListSegmentReport(segmentReport));
                                   setListSegmentReportApply(newListSegmentReportApply);
                              }

                              setSort(handleGetSortSegment({ listSegmentReportApply, filterMetric }));

                              const { removeSegmentSelected } = handleRemoveSegmentReportWithExternalCustomObjectReport(
                                   externalObjectReport,
                                   newListSegmentReportApply,
                              );
                              if (removeSegmentSelected.length) {
                                   const removeSegmentReportPayload = {
                                        reportName,
                                        reportType,
                                        accountId,
                                        segmentsEdit: removeSegmentSelected,
                                        segmentSticky,
                                        userId,
                                        isSaveReport,
                                        currentSegmentSticky: defaultConfig?.segmentSticky,
                                        listSegmentReportApply,
                                        object: SFObject,
                                        externalObjectReport: [...externalObjectReport, ...customExternalObjectReport.map((el) => { return { object: el.object, appearInReport: el.appearInReport, characteristicOtherObject: el.characteristicOtherObject } })],
                                   };
                                   callTokenApi(`${API_CLIENT_SEGMENT_REPORT}`, 'PUT', removeSegmentReportPayload);
                              }
                         }

                         setListChartSegmentApply(segmentChart);
                         setSegmentSticky(segmentSticky);
                         setDefaultConfig((prev) => ({ ...prev, segmentSticky }));

                         if (!isEmpty(defaultConfig) && !dataParamValue) {
                              const { dateRangeConfig: dateRangeDefault } = defaultConfig;
                              if (dateRangeDefault?.sticky && dateRangeDefault.selection) {
                                   const { compare, comparePeriod, datePreset, dateScope, periodType, selection } = dateRangeDefault;
                                   const newDefaultDateRange = {
                                        selection: {
                                             startDate: dayjs(selection.startDate),
                                             endDate: dayjs(selection.endDate),
                                        },
                                   };

                                   if (comparePeriod && compare) {
                                        newDefaultDateRange.compare = {
                                             startDate: dayjs(compare.startDate),
                                             endDate: dayjs(compare.endDate),
                                        };
                                   }

                                   let defaultDateRangeConfig = {
                                        comparePeriod,
                                        periodType,
                                        datePreset,
                                   }

                                   if (dateScopes.includes(dateScope)) {
                                        defaultDateRangeConfig.dateScope = dateScope;
                                   }

                                   setDateRangeConfig({
                                        ...dateRangeConfig,
                                        ...defaultDateRangeConfig,
                                        sticky: defaultConfig.dateRangeConfig.sticky,
                                   });

                                   if (!isSaveReport) {
                                        localStorage.setItem(SESSION_STORAGE_REPORT_DATE_RANGE, JSON.stringify({
                                             ...dateRangeConfig,
                                             ...defaultDateRangeConfig,
                                             ...newDefaultDateRange,
                                        }));
                                   }

                                   dispatch(setDateRangeReports(newDefaultDateRange));
                              } else {
                                   setDateRangeConfig({
                                        ...dateRangeConfig,
                                        sticky: defaultConfig.dateRangeConfig.sticky,

                                   });
                                   if (isEmpty(dateRangeReportNoSticky)) {
                                        dispatch(setDateRangeReports(defaultDateRange));
                                   } else {
                                        dispatch(setDateRangeReports(dateRangeReportNoSticky));
                                   }

                                   if (!isSaveReport) {
                                        localStorage.setItem(SESSION_STORAGE_REPORT_DATE_RANGE, JSON.stringify({
                                             ...dateRangeConfig,
                                             ...defaultDateRange,
                                        }));
                                   }

                              }

                              setDefaultConfig((prev) => {
                                   return { ...prev, dateRangeSticky: dateRangeDefault?.sticky }
                              })

                         }
                    });
                    if([REPORT_NAMES.PERSON_DETAILS,REPORT_NAMES.COMPANY_DETAILS].includes(reportName)) {
                         dispatch(fetchIntentProperties(accountId));
                    }
               }

               if (isConversionName) {
                    let salesConversionNameMetric = [];
                    let conversionNameMetric = [];
                    const conversionNameRateMetric = [];
                    const conversionName = [];
                    const conversionNameValue = [];
                    await callTokenApi(API_CLIENT_REPORTING_CONVERSION_NAME, 'POST', bodyData)
                         .then((response) => {
                              if (response?.status === 200) {
                                   const { conversionNameAll = [], lifeTimeConversionName, lifeTimeConversionValue } = response.data
                                   const conversionMetric = response.data.conversionName;
                                   const { eCommerceName } = response.data;
                                   const conversionValueMetric = response.data.conversionNameValue;

                                   conversionMetric.forEach((item) => {
                                        if (![REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
                                             conversionNameMetric.push({ key: item.value, label: item.label, type: item.type, name: item.name, section: SECTION_REPORT.WEB_CONVERSIONS, description: item.description });
                                        }
                                        conversionName.push({ label: item.label, value: item.value, convId: item.convId, type: item.type });
                                   });

                                   conversionValueMetric.forEach((item) => {
                                        conversionNameMetric.push({ key: item.value, label: item.label, convId: item.convId, type: item.type, name: item.name, section: SECTION_REPORT.WEB_CONVERSIONS, description: item.description })
                                   });

                                   if (reportType !== REPORT_TYPE.CONVERSIONS && reportType !== REPORT_TYPE.SALES_CONVERSION) {

                                        eCommerceName.forEach((item) => {
                                             conversionNameMetric.push({ key: item.value, label: item.label, type: item.type, section: SECTION_REPORT.ECOMMERCE });
                                             conversionName.push({ label: item.label, value: item.value, type: item.type });
                                        });
                                   }

                                   if ([REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
                                        lifeTimeConversionName.forEach((item) => {
                                             conversionNameMetric.push({ key: item.value, label: item.label, isDefault: false, section: SECTION_REPORT.WEB_CONVERSIONS, description: item.description, isHiddenChart: true })
                                        })
                                        lifeTimeConversionValue.forEach((item) => {
                                             conversionNameMetric.push({ key: item.value, label: item.label, isDefault: false, section: SECTION_REPORT.WEB_CONVERSIONS, description: item.description, isHiddenChart: true })
                                        })
                                   }

                                   if (isConversionNameRate) {
                                        const conversionRateMetric = response.data.conversionNameRate;
                                        conversionRateMetric.forEach((item) => {
                                             conversionNameRateMetric.push({ key: item.value, label: item.label, type: item.type, name: item.name, section: SECTION_REPORT.WEB_CONVERSIONS, description: item.description });
                                        });
                                   }
                                   if(isSalesConversionName) {
                                        const salesConversionLT = response.data.lifeTimeSalesConversionName;
                                        const salesConversionValueLT = response.data.lifeTimeSalesConversionValue;

                                        salesConversionLT.forEach((conversion) => {
                                             if(SFObject === conversion.objectName || customObjectSF === conversion.objectName || (SFObject === SCOPED.SF_EVENT && conversion.objectName === 'Event')) {
                                                  conversionName.push({ label: conversion.label, value: conversion.convId, convId: conversion.convId, type: conversion.type });
                                                  salesConversionNameMetric.push({ key: conversion.value, label: conversion.label, isDefault: false, section: SECTION_REPORT.SALE_CONVERSIONS, description: conversion.description, isHiddenChart: [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType) })
                                             }
                                        })
                                        salesConversionValueLT.forEach((conversion) => {
                                             if(SFObject === conversion.objectName || customObjectSF === conversion.objectName || (SFObject === SCOPED.SF_EVENT && conversion.objectName === 'Event')) {
                                                  salesConversionNameMetric.push({ key: conversion.value, label: conversion.label, isDefault: false, section: SECTION_REPORT.SALE_CONVERSIONS, description: conversion.description, isHiddenChart: [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType) })
                                             }
                                        })
                                   }

                                   conversionNameMetric = [...conversionNameMetric, ...conversionNameRateMetric, ...conversionNameValue, ...salesConversionNameMetric];

                                   if (isConversionAllReport) {
                                        conversionNameAll.forEach((item) => {
                                             conversionNameMetric.push({ key: item.value, label: item.label, convId: item.convId, type: item.type, name: item.name, section: SECTION_REPORT.WEB_CONVERSIONS, description: item.description });
                                        });
                                   }
                              }
                         })
                         .finally(() => {
                              setConversionNameMetric(conversionNameMetric);
                              setConversionName(conversionName);
                              setConversionNameLoading(false);
                         });
               } else {
                    setConversionNameMetric([]);
                    setConversionName([]);
                    setConversionNameLoading(false);
               }
          };
          fetchData();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     return conversionNameLoading;
};

export default useFirstFetchReportData;
